import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import abilityStore from '@/views/apps/abilidades/abilityStoreModule'
import appClientPedidos from '@/store/pedidos'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import timerStore from './timer'
import auth from './auth'
import admUsuario from '../views/apps/usuarios/userStoreModule'
import admGrupousuario from '../views/apps/grupos-usuarios/gruposStoreModule'
import admMenus from '../views/apps/fucionalidades-menus/menusStoreModule'
import admCategory from '../views/apps/categorias/CategoryStoreModule'
import admCliente from '../views/apps/clientes/ClienteStoreModule'
import appAdmProdutos from '../views/apps/produtos/ProdutosStoreModule'
import appLinkAfiliado from '../views/apps/produtos/LinkAfiliadoStoreModule'
import appAdmSaques from '../views/apps/financeiro/SaquesStoreModule'
import appAdmTabelaPreco from './tabela_preco'
import appAdmTabelaPrecoItem from './tabela_preco_item'
import admUfs from './uf'
import admCidade from './cidade'
import appAdminDashboard from './dashboards/Vendedor'
import appAdmItemImagem from './item_imagem'
import appGruposPermissions from './grupos-permissions'
import Notifications from './notifications'
import Banners from '../views/apps/banners/userBannerStore'
import minhaLoja from '../views/apps/minha-loja/minhaLojaStore'
import appPlanos from '../views/apps/planos/PlanosStoreModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    timerStore,
    auth,
    appUfs: admUfs,
    'app-adm-usuario': admUsuario,
    'app-adm-grupousuario': admGrupousuario,
    'app-adm-menus': admMenus,
    appAdmCategory: admCategory,
    appAdmCliente: admCliente,
    appAdmCidade: admCidade,
    appDashboards: appAdminDashboard,
    appAdmProdutos,
    appAdmSaques,
    appLinkAfiliado,
    appAdmTabelaPrecoItem,
    appAdmTabelaPreco,
    appAdmItemImagem,
    appGruposPermissions,
    abilityStore,
    appClientPedidos,
    Notifications,
    Banners,
    minhaLoja,
    appPlanos,
  },
  strict: process.env.DEV,
})
